import { useQuery } from "@tanstack/react-query";

import { generateExtractionPointName } from "@services/extractionPoints";

export const useGenerateExtractionPointName = ({
  params,
  ...options
}: {
  [key: string]: any;
  params: {
    level1ResourceId: string;
  };
}) => {
  return useQuery<number>({
    queryKey: ["extraction_point_name"],
    queryFn: () => generateExtractionPointName(params),
    enabled: Boolean(params.level1ResourceId),
    ...options,
  });
};
